module.exports = __webpack_public_path__ + "static/media/partners.10c45ebe.jpg";